module.exports = {"530825101":"恩乐镇","530825102":"按板镇","530825103":"勐大镇","530825104":"者东镇","530825105":"九甲镇","530825106":"古城镇","530825107":"振太镇","530825108":"和平镇","530825201":"田坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530825.json
// module id = 2410
// module chunks = 0